export const TIMEZONE = 'Asia/Seoul';
export const PERIODS = [{ key: 'today', label: '오늘' }, { key: 'week', label: '이번 주' }, { key: 'month', label: '이번 달' }, { key: 'custom', label: '기간 선택' }];
export const won = value => Number.isFinite(value) ? `${value.toLocaleString('ko-KR')}원` : '—';
export const count = (value, suffix) => Number.isFinite(value) ? `${value.toLocaleString('ko-KR')}${suffix}` : '—';
export function kstDate(value = new Date()) {
    return new Intl.DateTimeFormat('sv-SE', { timeZone: TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit' }).format(value);
}
export function kstLabel(value) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return '—';
    return new Intl.DateTimeFormat('ko-KR', { timeZone: TIMEZONE, month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(date);
}
export function validDateRange(start, end, today = kstDate()) {
    const valid = text => /^\d{4}-\d{2}-\d{2}$/.test(text) && Number.isFinite(Date.parse(text)) && new Date(text).toISOString().slice(0, 10) === text;
    return valid(start) && valid(end) && start <= end && end <= today && (Date.parse(end) - Date.parse(start)) / 86400000 < 366;
}
export function summaryParams(selection) {
    return { period: selection.period, timezone: TIMEZONE, ...(selection.period === 'custom' ? { start_date: selection.start, end_date: selection.end } : {}) };
}
// Reject malformed or partial success responses instead of turning missing financial data into zero.
export function parseSummary(data) {
    const amount = n => typeof n === 'number' && Number.isFinite(n) && Number.isSafeInteger(n);
    const total = n => amount(n) && n >= 0;
    const instant = value => typeof value === 'string' && /(?:Z|[+-]\d{2}:\d{2})$/.test(value) && Number.isFinite(Date.parse(value));
    if (data?.timezone !== TIMEZONE || !instant(data.as_of) || !instant(data.range?.start_at) || !instant(data.range?.end_at) || !['hour', 'day'].includes(data.range?.bucket) || !data.range?.label || Date.parse(data.range.start_at) > Date.parse(data.range.end_at)
        || !amount(data.summary?.earnings) || !total(data.summary?.transaction_count) || !total(data.summary?.merchant_count)
        || !amount(data.totals?.week_earnings) || !amount(data.totals?.month_earnings)
        || !Array.isArray(data.trend) || !data.trend.every(p => instant(p.bucket_start) && typeof p.label === 'string' && amount(p.earnings))
        || !Array.isArray(data.top_merchants) || !data.top_merchants.every(p => typeof p.merchant_id === 'string' && typeof p.merchant_name === 'string' && total(p.transaction_count) && amount(p.earnings))
        || (data.comparison != null && (!amount(data.comparison.difference) || typeof data.comparison.label !== 'string'))) {
        throw new Error('수익 데이터 형식을 확인할 수 없습니다. 잠시 후 다시 조회해주세요.');
    }
    return data;
}
export function walletNumber(value) {
    if (value == null || value === '' || typeof value === 'boolean') return null;
    const number = Number(value);
    return Number.isSafeInteger(number) && number >= 0 ? number : null;
}
export function parseWallet(data) {
    const raw = data || {};
    const balance = raw.balance && typeof raw.balance === 'object' ? raw.balance : raw;
    const available = walletNumber(balance.available_balance ?? raw.availableBalance);
    if (available == null) throw new Error('지갑 잔액을 확인할 수 없습니다.');
    // A general locked balance is not necessarily an in-flight withdrawal.
    return { available, pending: walletNumber(balance.pending_withdrawal_amount ?? raw.pending_withdrawal_amount) };
}
